@import '../../../scss/utility';
@import '../header.utility';
@import './flyout.utility';

@import './contextual-link-list.scss';
@import './contextual-teaser.scss';
@import './tool-list.scss';

.wb-header-flyout-container {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  bottom: 0;
  background-color: var(--wb-black);
  z-index: $z-index-header-flyout;

  @include breakpoint-from(mq3) {
    background-color: transparent;
    height: calc(100% - #{$_tablet-upper-header-total-height});
  }

  @include breakpoint-from(mq5) {
    height: calc(100% - #{$_desktop-upper-header-total-height}); //( upper part + main nav)
  }

  &__close-layer {
    position: fixed;
    width: 100%;
    bottom: 0;
    display: none;

    background: rgba(0, 0, 0, 0.8);

    @include breakpoint-from(mq3) {
      display: block;
      height: calc(100% - #{$_tablet-upper-header-total-height});
    }

    @include breakpoint-from(mq5) {
      height: calc(100% - #{$_desktop-upper-header-total-height}); // upper part + main nav
    }
  }

  &__inner {
    height: 100%;

    @include breakpoint-from(mq5) {
      @include wb-content-width;
      margin: 0 16px;
      position: relative;
    }
  }

  &--open {
    display: block;
  }
}

wb-header-flyout {
  --level-head-height: calc(100vw / 1.618);
  position: fixed;
  height: 100%;
  overflow: hidden;
  width: 100%;
  background: var(--wb-black);
  line-height: 24px;
  display: none;

  .wb-header-flyout__nav {
    padding-top: 6px; //to accomodate for the focus outline
  }

  @include breakpoint-from(mq3) {
    background: transparent;
    width: $_flyout-width-tablet;
  }

  @include breakpoint-between(mq3, mq5) {
    top: 120px;
    left: 24px;
  }

  @include breakpoint-from(mq5) {
    top: calc(#{$_desktop-upper-header-total-height} + #{$_flyout-margin});
  }

  &[level='2'],
  &[level='3'] {
    @include breakpoint-from(mq5) {
      position: absolute;
      top: $_flyout-margin; // position the flyout underneath the header
      height: calc(100% - #{$_flyout-margin * 2}); // calculate the height of the flyout by substracting the "margin" for top and bottom
    }
  }

  &[level='1'] {
    @include breakpoint-from(mq5) {
      display: none;
    }
  }

  &[level='2'] {
    @include breakpoint-from(mq3) {
      .wb-header-flyout__topbar-headline {
        opacity: 0;
      }
    }

    @include breakpoint-from(mq5) {
      width: $_flyout-width-desktop-level-2;

      .wb-header-flyout__back-arrow {
        display: none;
      }
    }
  }

  &[level='2'][scrolled] {
    @include breakpoint-from(mq3) {
      .wb-header-flyout__topbar-headline {
        opacity: 1;
      }
    }
  }

  &[level='3'] {
    @include breakpoint-from(mq5) {
      left: calc(#{$_flyout-width-desktop-level-2} + #{$_flyout-margin});
      width: $_flyout-width-desktop-level-3;

      .wb-header-flyout__x-button {
        display: none;
      }

      .wb-header-flyout__nav {
        width: $_flyout-content-width-desktop;
      }

      .wb-tool-list {
        &__item {
          margin-bottom: var(--wb-spacing-3xs);
          line-height: 48px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      .wb-header-flyout__nav-items {
        padding-top: 8px;
      }
    }
  }

  wb-icon {
    width: $_icon-size;
    height: $_icon-size;

    @include breakpoint-from(mq3) {
      color: var(--wb-black);
    }
  }

  &[scrolled] {
    @include breakpoint-from(mq3) {
      .wb-header-flyout__topbar-divider {
        opacity: 1;
      }
    }
  }

  &[open] {
    display: block;
  }
}

.wb-header-flyout {
  &__control {
    @extend %wb-button-normalizing;
    @extend %header-button-normalizing;
    @include wb-type-label;

    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    color: var(--wb-grey-60);
    background: transparent;
    cursor: pointer;
    position: relative;
    text-decoration: none;

    &:active,
    &:hover {
      color: var(--wb-white);
      text-decoration: none;
    }

    wb-icon {
      pointer-events: none;
      // preventing that it catches the click event!
    }

    // # .wb-header-nav Icon Modifier
    // used to display only a wb-icon element
    &--icon-only {
      @extend %square-button-size;
      padding: 0;

      wb-icon {
        margin-right: 0;
        width: 24px;
        height: 24px;
      }

      @include breakpoint-from(mq3) {
        width: $_tablet-menu-button-size;
        height: $_tablet-menu-button-size;
      }
    }

    &--mobile-only {
      @include breakpoint-from(mq3) {
        display: none !important;
      }
    }
  }

  &__legal-info {
    @include wb-type-hint;

    color: var(--wb-grey-60);
    margin-top: -20px;
    padding-left: 8px;
    padding-top: var(--wb-spacing-xxs);
    padding-bottom: 20px;

    @include breakpoint-between(mq3, mq5) {
      padding-left: var(--wb-spacing-s);
    }

    @include breakpoint-from(mq5) {
      padding-left: 0;
    }

    a {
      cursor: pointer;
      text-decoration: none;
      color: var(--wb-grey-60);
    }
  }

  &__bottom-section {
    padding: 0 var(--wb-spacing-s);

    @include breakpoint-from(mq3) {
      padding: 0 var(--wb-spacing-xs);
    }

    @include breakpoint-from(mq5) {
      padding: 0;
    }
  }

  &__footer {
    line-height: 56px;
    margin-bottom: var(--wb-spacing-s);
    padding-top: var(--wb-spacing-s);

    .wb-link {
      color: var(--wb-grey-45);
      @include wb-type-hint;
    }

    @include breakpoint-from(mq3) {
      position: relative;
      line-height: $_flyout-links-height-tablet-and-up;
      padding-left: var(--wb-spacing-s);
      padding-top: 0;

      &:before {
        @include flyout-border(top);
      }
    }

    @include breakpoint-from(mq5) {
      padding-left: 0;
      margin-top: 40px;
    }
  }

  &__x-button {
    margin-left: auto;

    @include breakpoint-from(mq5) {
      position: absolute;
      right: 16px;
    }
  }

  &__topbar {
    height: $_flyout-links-height-tablet-and-up;
    background: var(--wb-black);
    width: 100%;
    z-index: 1;
    position: sticky;
    top: 0;

    @include breakpoint-from(mq3) {
      background: var(--wb-white);
      height: 80px;
    }

    wb-icon {
      @include breakpoint-to(mq2) {
        color: var(--wb-white);
      }
    }
  }

  &__topbar-headline {
    @include wb-type-copy-strong;
    transition: opacity 200ms;
    color: var(--wb-black);
    pointer-events: none;

    @include breakpoint-to(mq2) {
      color: var(--wb-white);
      transition: 360ms linear;
    }
  }

  &__topbar-divider {
    display: none;

    @include breakpoint-from(mq3) {
      display: block;
      opacity: 0;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 1px;
      background-color: var(--wb-grey-95);
      margin: 0;
      border: none;
      box-shadow: var(--wb-shadow-level-2);
      transition: opacity 0.3s $wb-fade;
    }
  }

  &__topbar-outer {
    padding: var(--wb-spacing-xxs);

    @include breakpoint-from(mq3) {
      height: 100%;
      width: 320px;
      margin: 0 auto;
      padding: 0;
    }
  }

  &__topbar-inner {
    height: 100%;
    display: flex;
    align-items: center;
    color: var(--wb-grey-20);

    @include breakpoint-from(mq3) {
      padding-bottom: 0;
    }
  }

  &__body {
    display: flex; // make sure children may stretch to the height of this element
    align-items: stretch;
    flex-direction: column;
    position: absolute;
    top: 0;
    z-index: 1;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    height: 100%;
    scrollbar-width: none;
    overflow: -moz-scrollbars-none;
    -ms-overflow-style: none;

    @include breakpoint-from(mq3) {
      display: block;
      border-radius: $_flyout-border-radius;
      height: calc(100% - (96px + 48px));
      background: var(--wb-white);
    }

    @include breakpoint-from(mq5) {
      height: 100%;
    }
  }

  &__nav {
    // inside of level-inner

    flex: 1; // make sure container stretches to height of its parent (navContent)
    background: var(--wb-grey-90);
    padding-bottom: 40px;
    border-top-left-radius: $_flyout-border-radius;
    border-top-right-radius: $_flyout-border-radius;

    @include breakpoint-from(mq3) {
      border-radius: 0;
      background: transparent;
    }

    @include breakpoint-from(mq5) {
      width: 320px;
      margin: 0 auto;
    }
  }

  &__nav-headline {
    display: none;
    line-height: 44px;
    margin-bottom: var(--wb-spacing-xs);

    @include breakpoint-from(mq5) {
      @include wb-type-heading-m;
      display: block;
    }
  }

  &__nav-items {
    border-top-left-radius: $_flyout-border-radius;
    border-top-right-radius: $_flyout-border-radius;
    background: var(--wb-white);
    padding: var(--wb-spacing-xs);
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.1), 0 4px 8px 0 rgba(0, 0, 0, 0.1);
    position: relative;

    @include breakpoint-from(mq3) {
      padding: 0 var(--wb-spacing-xs);
      border-radius: 0;
      background: transparent;
      box-shadow: none;
    }

    @include breakpoint-from(mq5) {
      padding: 0;
    }

    li {
      position: relative;

      &:last-child:before {
        display: none;
      }

      &:before {
        @include flyout-border(bottom);

        @include breakpoint-from(mq5) {
          display: none;
        }
      }

      @include breakpoint-from(mq5) {
        &:last-child {
          a {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  &__nav-link {
    @extend %header-button-normalizing;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    // to reach the desirable link height of 40px (24px + font size of 18px + 24px)
    // 40px of left margin to accommodate the  arrow icon when there is a line-break
    text-decoration: none;
    width: 100%;

    .wb-header-flyout__control {
      pointer-events: none;
      margin-left: auto;
    }

    &:focus {
      outline: 1px solid var(--wb-blue-60);
      outline-offset: 5px;
    }

    @include breakpoint-from(mq5) {
      margin-bottom: var(--wb-spacing-xxs);
    }
  }

  &__nav-item {
    @include wb-type-copy;

    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    color: var(--wb-grey-20);
    font-weight: 500;
    padding-left: 8px;
    transition: 200ms transform ease-in-out;
    line-height: 72px;
    min-height: 72px;

    @include breakpoint-from(mq3) {
      line-height: $_flyout-links-height-tablet-and-up;
      min-height: $_flyout-links-height-tablet-and-up;
      padding-left: var(--wb-spacing-s);
    }

    @include breakpoint-from(mq5) {
      line-height: 40px;
      min-height: 40px;
      padding-left: 0;
    }

    wb-icon {
      color: var(--wb-grey-40);
    }

    &:hover {
      wb-icon {
        color: var(--wb-black);
      }

      .wb-header-flyout__nav-item-label {
        color: var(--wb-black);
      }
    }
  }

  &__nav-item--active {
    @include wb-type-copy-strong;

    wb-icon {
      transform: translateX(10px);
    }
  }
}

wb-header-flyout .wb-language-menu {
  padding-top: var(--wb-spacing-3xs);
  padding-bottom: var(--wb-spacing-3xs);
  justify-content: center;
}
